<script>
import EditFieldModal from './EditFieldModal.vue';

export default {
  components: {
    EditFieldModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    titleMobile: {
      type: String,
      default: '',
    },
    modalTitle: {
      type: String,
      default: 'Edit Title',
    },
    firstFieldLabel: {
      type: String,
      default: 'Title (Desktop)',
    },
    firstFieldPlaceholder: {
      type: String,
      default: 'Enter title for desktop',
    },
    secondFieldLabel: {
      type: String,
      default: 'Title (Mobile)',
    },
    secondFieldPlaceholder: {
      type: String,
      default: 'Enter title for mobile',
    },
    hideSecondField: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'save', 'delete'],
  computed: {
    hasContent() {
      return !!this.title;
    },
    fields() {
      const result = [
        {
          key: 'title',
          label: this.firstFieldLabel,
          placeholder: this.firstFieldPlaceholder,
          value: this.title,
          type: 'textarea',
          rows: 3,
        },
      ];
      if (!this.hideSecondField) {
        result.push({
          key: 'titleMobile',
          label: this.secondFieldLabel,
          placeholder: this.secondFieldPlaceholder,
          value: this.titleMobile,
          type: 'textarea',
          rows: 3,
        });
      }
      return result;
    },
  },
  methods: {
    handleSave(values) {
      this.$emit('save', values);
    },
    handleClose() {
      this.$emit('close');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<template>
  <EditFieldModal
    :visible="visible"
    :modal-title="modalTitle"
    :fields="fields"
    :show-delete="hasContent"
    @save="handleSave"
    @close="handleClose"
    @delete="handleDelete"
  />
</template>
